// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.services-section{
  position: relative;
  display: flex;
  height: 100vh;
  flex-wrap: wrap;
  z-index: 1;
  overflow:hidden;
  background: rgb(255, 255, 255, 0.1);
  justify-content: center;
  align-items: center;
}

.outer_dashboad{
  display: flex;
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;  
}

.circle_cont{
  display: flex;
  height: -moz-fit-content;
  height: fit-content;
  width: 100%;
  flex-wrap: wrap;
  margin-left: 10px;
}

.content-techskills{
  display: flex;
  flex-direction: column;
  width: 50%;
  height: -moz-fit-content;
  height: fit-content;  
  align-items: center;
  justify-content: center;
  color: var(--text-color);
}

.line_cont{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 100%;
  height: 300px;
  row-gap: 40px;
}

.content-profskills{
  display: flex;
  flex-direction: column;
  color: var(--text-color);
  width: 50%;
  height: -moz-fit-content;
  height: fit-content;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.content-profskills h1{
  width: -moz-fit-content;
  width: fit-content;
  margin-bottom: 25px;
}

.content-techskills h1{
  width: -moz-fit-content;
  width: fit-content;
  margin-bottom: 25px;
}

@media(max-width:998px){
  .services-section{
    height: -moz-fit-content;
    height: fit-content;
    align-items: center;
    justify-content: center;
  }

  .services-section h5{
    display: flex;
    color: var(--text-color);
    margin-top: 25%;
    font-size: 1.9rem;
  }

  .services-section h1{
    margin-top: 25%;
    display: flex;
    color: var(--text-color);
  }

  .content-techskills{
    margin-top: 20%;
    width: 100%;
    height: -moz-fit-content;
    height: fit-content;
  }

  .circle_cont{
    margin-top: 10%;
    margin-left: 0%;
  }

  .line_cont{
    margin-top: 20%;
    height: 400px;
  }
  
  .content-profskills{
    margin-top: 0%;
    width: 100%;
  }
  .circle_cont{
    width: 100%;
  align-items: center;
  justify-content: center;
  }

  .outer_dashboad{
    margin-top: -10%;
  flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Dashboard.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,eAAe;EACf,UAAU;EACV,eAAe;EACf,mCAAmC;EACnC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,wBAAmB;EAAnB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,wBAAmB;EAAnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,wBAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,WAAW;EACX,aAAa;EACb,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,UAAU;EACV,wBAAmB;EAAnB,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAmB;IAAnB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,wBAAwB;IACxB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,WAAW;IACX,wBAAmB;IAAnB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;EACb;EACA;IACE,WAAW;EACb,mBAAmB;EACnB,uBAAuB;EACvB;;EAEA;IACE,gBAAgB;EAClB,sBAAsB;EACtB;AACF","sourcesContent":["\n.services-section{\n  position: relative;\n  display: flex;\n  height: 100vh;\n  flex-wrap: wrap;\n  z-index: 1;\n  overflow:hidden;\n  background: rgb(255, 255, 255, 0.1);\n  justify-content: center;\n  align-items: center;\n}\n\n.outer_dashboad{\n  display: flex;\n  height: fit-content;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;  \n}\n\n.circle_cont{\n  display: flex;\n  height: fit-content;\n  width: 100%;\n  flex-wrap: wrap;\n  margin-left: 10px;\n}\n\n.content-techskills{\n  display: flex;\n  flex-direction: column;\n  width: 50%;\n  height: fit-content;  \n  align-items: center;\n  justify-content: center;\n  color: var(--text-color);\n}\n\n.line_cont{\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  width: 100%;\n  height: 300px;\n  row-gap: 40px;\n}\n\n.content-profskills{\n  display: flex;\n  flex-direction: column;\n  color: var(--text-color);\n  width: 50%;\n  height: fit-content;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.content-profskills h1{\n  width: fit-content;\n  margin-bottom: 25px;\n}\n\n.content-techskills h1{\n  width: fit-content;\n  margin-bottom: 25px;\n}\n\n@media(max-width:998px){\n  .services-section{\n    height: fit-content;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .services-section h5{\n    display: flex;\n    color: var(--text-color);\n    margin-top: 25%;\n    font-size: 1.9rem;\n  }\n\n  .services-section h1{\n    margin-top: 25%;\n    display: flex;\n    color: var(--text-color);\n  }\n\n  .content-techskills{\n    margin-top: 20%;\n    width: 100%;\n    height: fit-content;\n  }\n\n  .circle_cont{\n    margin-top: 10%;\n    margin-left: 0%;\n  }\n\n  .line_cont{\n    margin-top: 20%;\n    height: 400px;\n  }\n  \n  .content-profskills{\n    margin-top: 0%;\n    width: 100%;\n  }\n  .circle_cont{\n    width: 100%;\n  align-items: center;\n  justify-content: center;\n  }\n\n  .outer_dashboad{\n    margin-top: -10%;\n  flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
